module.exports = __webpack_public_path__ + "static/posts-2-bf5c043ff0f9a2fe28d7381790652af8.jpg";